import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
    AppBlockPort,
    AppBlockLinkParameter,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import NodeArgument from '@appblocks/codegeneration/Nodes/NodeArgument';
import * as tios from './tios';
import * as simulator from './simulator';

export default class TableUpdateNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Table Update Row';
        this.id = 'node_table_update';
        this.icon = 'HiOutlineDatabase';
        this.requirements = ['tios'];
        this.linkedFeature = 'general';
        this.inputs = [
            {
                name: 'Update Row',
                portId: 'tbl_update',
                params: [],
            },
        ];

        const settings = [
            {
                id: 'TABLE',
                name: 'Table',
                settingType: SettingType.OPTION,
                refId: 'tbl_table',
                required: true,
                default: '',
                options: [] as any[],
            },
            {
                id: 'FIELD_NAME',
                name: 'Field Name',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
                options: [] as any[],
            },
            {
                id: 'OPERATOR',
                name: 'Operator',
                settingType: SettingType.OPTION,
                required: true,
                default: '=',
                options: [
                    {
                        name: 'Equals',
                        value: 'PL_FD_FIND_EQUAL',
                    },
                    {
                        name: 'Not Equal',
                        value: 'PL_FD_FIND_NOT_EQUAL',
                    },
                    {
                        name: 'Greater Than',
                        value: 'PL_FD_FIND_GREATER',
                    },
                    {
                        name: 'Greater Than Equal To',
                        value: 'PL_FD_FIND_GREATER_EQUAL',
                    },
                    {
                        name: 'Less Than',
                        value: 'PL_FD_FIND_LESSER',
                    },
                    {
                        name: 'Less Than Equal To',
                        value: 'PL_FD_FIND_LESSER_EQUAL',
                    },
                ],
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
            {
                id: 'FIELDS',
                name: 'Fields',
                settingType: SettingType.ARRAY,
                refId: 'table_update_field_value',
                required: true,
                default: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        const project: ProjectConfiguration = this.project;
        const TABLE = project.getFeature(this.getSettingValue('TABLE'));
        if (TABLE === undefined) {
            return super.getSettingOptions(settingId);
        }
        const FIELDS = TABLE.getSettingValue('FIELDS');
        if (settingId === 'FIELD_NAME') {
            return FIELDS.map((field: BaseFeature) => ({
                name: `${field.getSettingValue('NAME')} (${field.getSettingValue('DISPLAY_NAME')})`,
                value: field.getSettingValue('NAME'),
            }));
        }
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
